import { Columns, Column, Badge, Checkbox } from 'braid-design-system';

interface Props {
  id: string;
  text: string;
  count?: number;
  isSelected?: boolean;
  disabled?: boolean;
  onSelect: () => void;
  isPreferred?: boolean;
}

export const CheckboxRow = ({
  id,
  text,
  count,
  isSelected = false,
  disabled = false,
  onSelect,
  isPreferred = false,
}: Props) => (
  <Columns space="small" alignY="center">
    <Column>
      <Checkbox
        id={id}
        label={`${text}${isPreferred ? '\u00A0*' : ''}`}
        size="small"
        disabled={disabled}
        checked={isSelected}
        onChange={onSelect}
      />
    </Column>
    {count !== undefined ? (
      <Column width="content">
        <Badge tone="neutral">{count.toString()}</Badge>
      </Column>
    ) : null}
  </Columns>
);
